const API_ENDPOINT = 'https://usdepartmentofinterior.azurewebsites.net/chat';

export const sendMessageToBot = async (message, sessionId) => {
    try {
        const response = await fetch(API_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                message: message,
                session_id: sessionId
            })
        });

        if (!response.ok) {
            throw new Error(`API call failed: ${response.statusText}`);
        }

        const data = await response.json();

        return {
            text: data.answer,
            sender: 'bot',
            timestamp: new Date().toISOString(),
            urls: data.urls || [],
            searchResults: data.result || [] // Store full search results for citations
        };
    } catch (error) {
        console.error('Error calling Chat API:', error);
        throw error;
    }
};
